import "../assets/qreader.css";
import { useCallback, useState, useEffect, useRef } from "react";
import { Dialog } from "@headlessui/react";
import { Scanner } from "@yudiel/react-qr-scanner";
import { axiosInstance } from "../utils/axios";
import { toast } from "react-toastify"; // Add toast for b
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import useDialogStore from "../stores/useDialogStore";

export default function PrintByIds() {
  const navigate = useNavigate();
  const { closeDialog } = useDialogStore();
  const [multipleQueries, setMultipleQueries] = useState("");

  const deviceLookupMutation = useMutation({
    mutationFn: async (multipleQueries) => {
      if (!multipleQueries.trim()) return [];
      const queryString = encodeURIComponent(
        multipleQueries.split("\n").filter(Boolean).join(",")
      );
      const { data } = await axiosInstance.get(
        `${window.REACT_APP_API_ENDPOINT}/device/lookup/multiple?query=${queryString}`
      );
      return Array.isArray(data.data) ? data.data : [data.data];
    },
    onSuccess: (response) => {
      if (response) {
        const ids = response.map((device) => device.id).join(",");
        console.log("ids", ids);
        window.location.href = `/devices/multi-device-details?ids=${ids}`;
        closeDialog();
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Device not found");
    },
  });

  return (
    <div className="">
      <div className="mb-2 text-sm text-gray-700">
        Enter Unique IDs (one per line)
      </div>
      <textarea
        className="w-full border rounded-md p-2 min-h-[100px] text-gray-900 placeholder:text-gray-400 text-sm"
        placeholder="Type or paste and press Enter..."
        value={multipleQueries}
        onChange={(e) => setMultipleQueries(e.target.value)}
        onPaste={(e) => {
          e.preventDefault();
          const pastedData = e.clipboardData.getData("Text");
          setMultipleQueries((prev) => prev + " " + pastedData);
        }}
        autoFocus
      />
      <div className="text-xs text-gray-500 mb-3">
        Paste a list of values or press Enter after each entry
      </div>
      <div className="flex justify-end">
        <button
          onClick={() => deviceLookupMutation.mutate(multipleQueries)}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
          disabled={!multipleQueries.trim()}
        >
          Print All
        </button>
      </div>
    </div>
  );
}
